/**
 * @fileoverview PUT handler for the "/engagement/report_tile/:tile_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportTileTileIdCacheKeys } from "./constants";
import type { PutEngagementReportTileTileIdProps, EngagementReportTileTileIdResult } from "./types";

export const putEngagementReportTileTileId = reactQueryMutationAdapter(
  engagementReportTileTileIdCacheKeys,
  (props: PutEngagementReportTileTileIdProps): Promise<EngagementReportTileTileIdResult> => {
    return fetch(`/engagement/report_tile/${props.tile_id}`, "PUT", props);
  }
);
